<template>
    <Head title="OCP: User"/>

    <authenticated-layout :notifications="notifications" >

        <template #header>
            <navigation :user-id="userId"/>
        </template>

        <div class="bg-white p-4">
            <div class="flex flex-col border-b  gap-2 p-2" v-for="ses in result">
                <div class="grid grid-cols-3">
                    <v-label>IP</v-label>
                    <v-label>Session Key</v-label>
                    <v-label>Начата (UTC)</v-label>
                    <strong>{{ ses.ip }}</strong>
                    <span>{{ ses.sKey }}</span>
                    <span>{{ moment(ses.since).utc().format('L LTS') }}</span>
                </div>
                <div class="grid grid-cols-3">
                    <v-label>Node ID</v-label>
                    <v-label class="col-span-2">User Agent</v-label>
                    <p class="text-sm">{{ ses.nodeId }}</p>
                    <p class="text-sm col-span-2">{{ ses.ua }}</p>
                </div>
                <div class="flex flex-row justify-end gap-4">
                    <v-button @click="drop({id:ses.id})" color="red">Раскинуть на всех нодах</v-button>
                    <v-button @click="drop({id:ses.id, nodeId: ses.nodeId})" color="red">Раскинуть</v-button>
                </div>
            </div>
        </div>

    </authenticated-layout>

</template>

<script>
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import Navigation from '@/Components/Navigation/User';
import VInput from "@/Components/Input";
import VButton from "@/Components/Button";
import VButtonLink from "@/Components/ButtonLink";
import VLabel from "@/Components/Label";
import moment from "moment";
import ButtonSecondary from "@/Components/ButtonSecondary.vue";

export default {
    components: {
        ButtonSecondary,
        Head, Link, useForm,
        AuthenticatedLayout,
        Navigation,
        VInput,
        VButton,
        VButtonLink,
        VLabel,
    },
    props: {
        userId: String,
        success: Boolean,
        result: Object,
        notifications: Object,
    },
    methods: {
        moment,
        drop(data) {
            this.notifications.push({
                type: 'success',
                title: 'Waiting...'
            })
            useForm(data).post(this.route('user.sessions.drop', this.userId))
        },
    },
}
</script>
